import React from 'react';
import { AboutContainer, AboutTitle, AboutInfo } from './index.styles';
const About = () => (
	<div>
		<AboutContainer className="container">
			<AboutTitle className="title-font"> چابک باشید! چابک بمانید!چابک پیش بروید!</AboutTitle>
			<AboutInfo>
				این پیام ما برای پارتنر های عزیزمان هست !
				<br />
				محصولات ما اماده هست تا به تیم چابک شما کمک کند تا پروژه های بزرگ را برنامه ریزی، پیگیری و بسازد ما شما را در این راه همراهی خواهیم کرد
			</AboutInfo>
		</AboutContainer>
	</div>
);

export default About;
